import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigatorComponent } from './navigator.component';
import { FuseLoadingBarModule } from "../../../../@fuse/components/loading-bar";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { RouterLink, RouterLinkActive, RouterOutlet } from "@angular/router";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import { InitialsPipe } from "../../../shared/pipes/initials.pipe";


@NgModule({
    declarations: [
        NavigatorComponent
    ],
    imports: [
        CommonModule,
        FuseLoadingBarModule,
        MatButtonModule,
        MatIconModule,
        RouterLinkActive,
        RouterOutlet,
        RouterLink,
        MatProgressSpinnerModule,
        InitialsPipe
    ],
    exports: [NavigatorComponent]
})
export class NavigatorModule {
}
